import * as tslib_1 from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { initUploadAccessInfo, refreshUploadAccessInfo } from "@/api/material";
import { getVideoDetailList, requestVideoDelete, requestVideoSave, getPlayerUrl } from '@/api/live';
let VideoBank = class VideoBank extends Vue {
    constructor() {
        super(...arguments);
        this._aliUploader = null; // 阿里云上传器
        // 阿里云上传器访问权限
        this._aliAccess = {
            uploadAuth: "",
            uploadAddress: "",
            videoId: "",
        };
        this.isVideoUploading = false;
        this.loading = false;
        this.videos = [];
        this.searcher = {
            title: '',
            _title: '',
        };
        this.paginator = {
            pageNo: 1,
            pageSize: 20,
            total: 0,
        };
        this.liveModal = {
            visible: false,
            list: [],
            _list: [],
            paginator: {
                pageNo: 1,
                pageSize: 10,
                total: 0,
            }
        };
        this.videoPlayer = {
            isVisible: false,
            src: "",
        };
    }
    created() {
        this.loadVideoList();
        // 配置阿里云上传器
        const AliyunUpload = window.AliyunUpload;
        this._aliUploader = new AliyunUpload.Vod({
            userId: "1197011945138604",
            region: "cn-shanghai",
            partSize: 10485760,
            parallel: 5,
            retryCount: 3,
            retryDuration: 2,
            enableUploadProgress: true,
            onUploadstarted: this.handleVideoUploadStart,
            onUploadSucceed: this.handleVideoUploadSucceed,
            onUploadFailed: () => {
                this.$message.error("上传失败");
                this.isVideoUploading = false;
            },
            onUploadTokenExpired: () => {
                this.$message.error("上传凭证已失效");
                this.isVideoUploading = false;
            },
        });
    }
    async loadVideoList() {
        this.loading = true;
        const params = {
            name: this.searcher._title,
            pageNo: this.paginator.pageNo,
            pageSize: this.paginator.pageSize
        };
        try {
            const res = await getVideoDetailList(params);
            const data = res.data.data;
            this.videos = data.list || [];
            this.paginator.total = Number(data.total);
        }
        catch (error) {
            console.error(error);
        }
        finally {
            this.loading = false;
        }
    }
    handleVideoSearch() {
        this.searcher._title = this.searcher.title;
        this.paginator.pageNo = 1;
        this.loadVideoList();
    }
    handlePageChange(pageNo) {
        this.paginator.pageNo = pageNo;
        this.loadVideoList();
    }
    showLivesModal(lives) {
        if (!lives.length)
            return;
        this.liveModal = {
            visible: true,
            list: lives.slice(0, 10),
            _list: lives,
            paginator: {
                pageNo: 1,
                pageSize: 10,
                total: lives.length,
            }
        };
    }
    closeLiveModal() {
        this.liveModal.visible = false;
    }
    handleLivePageChange(pageNo) {
        this.liveModal.paginator.pageNo = pageNo;
        const pageSize = this.liveModal.paginator.pageSize;
        const start = (pageNo - 1) * pageSize;
        this.liveModal.list = this.liveModal._list.slice(start, start + pageSize);
    }
    async handleVideoDelete(video) {
        if (video.liveNameList.length) {
            return this.$message.error('该视频已关联直播，需到关联直播将该视频移除');
        }
        try {
            await this.$confirm('是否确认删除该视频', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            });
        }
        catch (error) {
            return;
        }
        try {
            await requestVideoDelete(video.id);
            this.$message.success('删除成功');
            this.loadVideoList();
        }
        catch (error) {
            console.error(error);
        }
    }
    // 选择视频文件
    handleVideoSelect(file) {
        const isLt3G = file.size / 1024 / 1024 / 1024 < 3;
        if (!isLt3G) {
            this.$message.error("视频文件大小不能超过 3G!");
            return false;
        }
        const isMP4 = file.type === "video/mp4";
        if (!isMP4) {
            this.$message.error("视频文件只能是MP4格式!");
            return false;
        }
        return true;
    }
    // 上传视频文件
    async handleVideoUpload(data) {
        this.isVideoUploading = true;
        const file = data.file;
        this._aliUploader.addFile(file, null, null, null, '{"Vod":{}}');
        this._aliUploader.startUpload();
    }
    // 阿里云上传器预处理（上传视频文件）
    async handleVideoUploadStart(uploadInfo) {
        //上传方式，需要根据uploadInfo.videoId是否有值（该值由SDK通过localstorage获取），调用视频点播的不同接口获取uploadauth和uploadAddress，如果videoId有值，调用刷新视频上传凭证接口，否则调用创建视频上传凭证接口
        //上传过程中，如果在点播控制台删除了视频，即videoId不存在了，则会产生冲突，会出现控制台不存在videoId，而浏览器存在videoId的情况，报InvalidVideo.NotFound错误。此时，需手动清除localstorage 
        const isAuth = uploadInfo.videoId ? await this.handleUploadAccess('refresh', uploadInfo.videoId) : await this.handleUploadAccess('init', uploadInfo.file.name);
        if (!isAuth) {
            this.isVideoUploading = false;
            return this._aliUploader.cleanList();
        }
        const access = this._aliAccess;
        this._aliUploader.setUploadAuthAndAddress(uploadInfo, access.uploadAuth, access.uploadAddress, access.videoId);
    }
    // 阿里云上传器上传成功（上传视频文件）
    async handleVideoUploadSucceed(uploadInfo) {
        this.isVideoUploading = false;
        console.log(uploadInfo);
        try {
            await requestVideoSave({
                videoId: uploadInfo.videoId,
                videoName: uploadInfo.file.name,
                videoUrl: uploadInfo.checkpoint.name,
            });
            this.loadVideoList();
            this.$message.success("上传成功");
        }
        catch (error) {
            console.error(error);
        }
    }
    // 获取阿里云授权
    // type init(with videoName) refresh(with videoId)
    async handleUploadAccess(type, token) {
        const res = type === 'init'
            ? await initUploadAccessInfo(token)
            : await refreshUploadAccessInfo(token);
        if (res.data.status !== 200)
            return false;
        const data = res.data.data;
        if (!data)
            return false;
        this._aliAccess = {
            uploadAuth: data.uploadAuth,
            uploadAddress: data.uploadAddress,
            videoId: data.videoId,
        };
        return true;
    }
    async showVideoPlayer(id) {
        const res = await getPlayerUrl(id);
        if (res.data.status !== 200)
            return;
        const data = res.data.data;
        // 校验是否成功获取视频播放地址
        if (!data)
            return this.$message.error("初始化失败");
        this.videoPlayer = {
            isVisible: true,
            src: data,
        };
    }
    destroyVideoPlayer() {
        this.videoPlayer = {
            isVisible: false,
            src: "",
        };
    }
};
VideoBank = tslib_1.__decorate([
    Component({
        name: 'VideoBank'
    })
], VideoBank);
export default VideoBank;
